import React from 'react';
import {withScreenCheck} from '../hoc';

class Error404 extends React.Component {
  static displayName = 'Error404';
  static propTypes = {};
  static defaultProps = {};
  /**
   * @override
   */
  render() {
    return (
      <div className="Error404">
        <a href="/" className="gohome">
          ❮
        </a>
        <div className="title">404 – NOT FOUND</div>
        <div className="text">La page désirée n'a pas été trouvée</div>
      </div>
    );
  }
}

export default withScreenCheck(Error404);
